import Component from 'gia/Component';

import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      path: {},
      openMenu: {},
      closeMenu: {},
      menu: {},
    }
  }

  mount() {
    let tl = gsap.timeline({
      repeat: -1, yoyo: true
    });
    tl.to(this.ref.path, {
      fill: '#f97373',
      duration:2
    },"+=2");
    tl.to(this.ref.path, {
      fill: '#ffb600',
      duration:2
    },"+=2");
    tl.to(this.ref.path, {
      fill: '#aaa1f8',
      duration:2
    },"+=2");
    tl.to(this.ref.path, {
      fill: '#1b4134',
      duration:2
    },"+=2");


    this.ref.openMenu.addEventListener('click', () => {
      this.ref.menu.classList.remove('hidden');
    });
    this.ref.closeMenu.addEventListener('click', () => {
      this.ref.menu.classList.add('hidden');
    });
  }


}